var _rect, _rect2, _rect3, _circle, _ellipse, _ellipse2, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.6365,
    y: 21.2727,
    width: 2.72727,
    height: 36.8182,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 2.72727,
    height: 61.3636,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2727,
    y: 9,
    width: 2.72727,
    height: 61.3636,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6527,
    cy: 39.3477,
    r: 12.6204,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4653,
    cy: 35.1386,
    rx: 1.46282,
    ry: 1.82852,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.4442,
    cy: 39.1613,
    rx: 1.82852,
    ry: 1.46282,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4653,
    cy: 43.55,
    r: 1.46282,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8542,
    cy: 39.1613,
    r: 1.46282,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6527 51.9683C32.6937 51.9683 27.0322 46.3067 27.0322 39.3477C27.0322 32.3888 32.6937 26.7273 39.6527 26.7273C46.6117 26.7273 52.2731 32.3888 52.2731 39.3477C52.2731 46.3067 46.6115 51.9683 39.6527 51.9683ZM39.6527 27.3599C33.0425 27.3599 27.6647 32.7377 27.6647 39.3477C27.6647 45.9579 33.0424 51.3357 39.6525 51.3357C46.2627 51.3357 51.6404 45.9579 51.6404 39.3477C51.6405 32.7377 46.2627 27.3599 39.6527 27.3599ZM39.6527 48.7816C34.4509 48.7816 30.2189 44.5497 30.2189 39.3477C30.2189 34.1461 34.4509 29.914 39.6527 29.914C44.8545 29.914 49.0864 34.146 49.0864 39.3477C49.0864 44.5495 44.8543 48.7816 39.6527 48.7816ZM39.6527 30.5468C34.7997 30.5468 30.8516 34.4949 30.8516 39.3479C30.8516 44.2008 34.7997 48.1491 39.6527 48.1491C44.5056 48.1491 48.4538 44.2009 48.4538 39.3479C48.4538 34.4949 44.5056 30.5468 39.6527 30.5468ZM39.6527 45.5258C38.5948 45.5258 37.7341 44.6652 37.7341 43.6073C37.7341 42.5494 38.5948 41.6886 39.6527 41.6886C40.7106 41.6886 41.5712 42.5494 41.5712 43.6073C41.5712 44.6652 40.7104 45.5258 39.6527 45.5258ZM39.6527 42.3213C38.9436 42.3213 38.3668 42.8982 38.3668 43.6073C38.3668 44.3163 38.9436 44.8932 39.6527 44.8932C40.3617 44.8932 40.9386 44.3162 40.9386 43.6073C40.9386 42.8982 40.3617 42.3213 39.6527 42.3213ZM43.9121 41.2663C42.8542 41.2663 41.9935 40.4056 41.9935 39.3477C41.9935 38.2898 42.8542 37.4292 43.9121 37.4292C44.97 37.4292 45.8307 38.2898 45.8307 39.3477C45.8307 40.4056 44.97 41.2663 43.9121 41.2663ZM43.9121 38.0618C43.203 38.0618 42.6262 38.6388 42.6262 39.3477C42.6262 40.0567 43.203 40.6336 43.9121 40.6336C44.6211 40.6336 45.1981 40.0567 45.1981 39.3477C45.1981 38.6388 44.6211 38.0618 43.9121 38.0618ZM35.3933 41.2663C34.3354 41.2663 33.4747 40.4056 33.4747 39.3477C33.4747 38.2898 34.3354 37.4292 35.3933 37.4292C36.4512 37.4292 37.3118 38.2898 37.3118 39.3477C37.3118 40.4056 36.451 41.2663 35.3933 41.2663ZM35.3933 38.0618C34.6842 38.0618 34.1074 38.6388 34.1074 39.3477C34.1074 40.0567 34.6842 40.6336 35.3933 40.6336C36.1023 40.6336 36.6792 40.0567 36.6792 39.3477C36.6792 38.6388 36.1023 38.0618 35.3933 38.0618ZM39.6527 37.0069C38.5948 37.0069 37.7341 36.1462 37.7341 35.0883C37.7341 34.0304 38.5948 33.1698 39.6527 33.1698C40.7106 33.1698 41.5712 34.0304 41.5712 35.0883C41.5712 36.1462 40.7104 37.0069 39.6527 37.0069ZM39.6527 33.8024C38.9436 33.8024 38.3668 34.3794 38.3668 35.0883C38.3668 35.7973 38.9436 36.3742 39.6527 36.3742C40.3617 36.3742 40.9386 35.7973 40.9386 35.0883C40.9386 34.3794 40.3617 33.8024 39.6527 33.8024Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacket);
export default __webpack_public_path__ + "static/media/placket.97a7947b5237dbe0062c41e447109928.svg";
export { ForwardRef as ReactComponent };